const styles = theme => ({
  template: {
    height: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  blockContainer: {
    backgroundColor: "rgba(255,255,255, 0.1)",
    flexGrow: 1
  },
  blockContainerEmpty: {
    flexGrow: 1
  },
  "top-left": {
    flexBasis: "50%",
    height: "40%",
    display: "flex",
    paddingRight: 2.5
  },
  "top-right": {
    flexBasis: "50%",
    height: "40%",
    display: "flex",
    paddingLeft: 2.5
  },
  bottom: {
    flexBasis: "100%",
    height: "60%",
    display: "flex",
    paddingTop: 5
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/Layouts/TwoColumnLowerThird/styles.js